/**
 * Retrieve the whole state object for the action bar.
 */
export const actionBarStateSelector = state => state.ui.actionBar;

export const activeButtonSelector = state => state.ui.actionBar.buttonActive;
